import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    document.documentElement.classList.add("js")

    if (typeof IntersectionObserver === "undefined") {
      this.element.classList.add("is-visible")
      return
    }
    this.observer = new IntersectionObserver((entries, obs) => {
      entries.forEach((e) => {
        if (e.isIntersecting) {
          e.target.classList.add("is-visible")
          obs.unobserve(e.target)
        }
      })
    }, { threshold: 0.1 })
    this.observer.observe(this.element)
  }

  disconnect() {
    this.observer?.disconnect()
  }
}
